import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import VehiclesList from './pages/VehiclesList';
import VehicleDetail from './pages/VehicleDetail';
import AddVehicle from './pages/AddVehicle';
import EditVehicle from './pages/EditVehicle';
import SoldVehicles from './pages/SoldVehicles';
import PublicCatalogue from './pages/PublicCatalogue';
import CarteVisite from './pages/CarteVisite';
import Login from './pages/Login';
import Sidebar from './components/Sidebar';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './lib/AuthContext';
import ProtectedRoute from './lib/ProtectedRoute';
import './lib/api'; // side-effect: axios.defaults.withCredentials = true
import './App.css';

const AdminShell = () => (
  <ProtectedRoute>
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar />
      <div className="flex-1 ml-64">
        <header className="sticky top-0 z-10 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-b border-red-600/30 px-8 py-4 shadow-lg">
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets.emergentagent.com/job_auto-flip-tracker-1/artifacts/mote16qp_26609.jpg"
              alt="Groupe Auto Prestige"
              className="h-16 w-auto object-contain"
            />
            <div className="border-l border-slate-600 pl-4">
              <h1 className="text-xl font-bold text-white tracking-tight" style={{ fontFamily: 'Manrope' }}>
                Gestion Véhicules
              </h1>
              <p className="text-xs text-slate-400 font-medium">Plateforme Professionnelle</p>
            </div>
          </div>
        </header>
        <main className="p-6 md:p-8 max-w-7xl mx-auto">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/vehicles" element={<VehiclesList />} />
            <Route path="/vehicles/sold" element={<SoldVehicles />} />
            <Route path="/vehicles/:id" element={<VehicleDetail />} />
            <Route path="/vehicles/new" element={<AddVehicle />} />
            <Route path="/vehicles/:id/edit" element={<EditVehicle />} />
          </Routes>
        </main>
      </div>
    </div>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<PublicCatalogue />} />
            <Route path="/catalogue" element={<PublicCatalogue />} />
            <Route path="/carte" element={<CarteVisite />} />
            <Route path="/login" element={<Login />} />

            {/* Admin routes (protected) */}
            <Route path="/*" element={<AdminShell />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
